import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import ApiFaq from "@/api/ApiFaq";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditorConfig from "@/data/CKeditor/config";
let CreateQuestion = class CreateQuestion extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.editorConfig = CKEditorConfig.editorConfig(ApiEnter.CurrentSessionUUID);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Главная",
            },
            {
                to: "/secure/faq",
                exact: true,
                text: "CMS",
            },
            {
                to: "/secure/faq",
                exact: true,
                text: "Поддержка (FAQ)",
            },
            {
                text: "Вопросы",
                disabled: true,
            },
        ];
        this.FaqCategories = [];
        this.newPost = {
            answer: "",
            question: "",
            publish: true,
            priority: "",
            category: "",
            display_home: false,
        };
        this.HasLoading = false;
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const blog_uuid = await ApiFaq.CreateFaqQuestion(ApiEnter.CurrentSessionUUID, this.newPost.answer, this.newPost.question, this.newPost.priority, this.newPost.publish ? 1 : 0, this.newPost.category, this.newPost.display_home ? 1 : 0);
            if (blog_uuid == undefined || blog_uuid.length != 36) {
                sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.newPost.answer = "";
                this.newPost.question = "";
                this.newPost.priority = "";
                this.newPost.publish = true;
                this.newPost.category = "";
                this.newPost.display_home = "";
                this.$router.push(`/secure/faq`);
            });
        }
        this.HasLoading = false;
    }
    async GetFaqCategories() {
        try {
            this.FaqCategories = await ApiFaq.GetFaqCategories(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    created() {
        this.GetFaqCategories();
    }
};
CreateQuestion = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, CKEditor },
    })
], CreateQuestion);
export default CreateQuestion;
